"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Editor = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PostEditor = _interopRequireDefault(require("@insided/shared/uikit/PostEditor"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _AvatarPlaceholder = _interopRequireDefault(require("@insided/destination/icons/AvatarPlaceholder"));

var _userAvatar = require("@insided/shared/utils/userAvatar");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this$props$attachmen;

    var _this;

    (0, _classCallCheck2.default)(this, Editor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.content,
      attachments: (_this$props$attachmen = _this.props.attachments) !== null && _this$props$attachmen !== void 0 ? _this$props$attachmen : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        content: content,
        attachments: attachments
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Editor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          onFocus = _this$props.onFocus,
          _onCancel = _this$props.onCancel,
          placeholder = _this$props.placeholder,
          parentTopicId = _this$props.parentTopicId,
          contentType = _this$props.contentType,
          disableFileAttachments = _this$props.disableFileAttachments,
          currentUser = _this$props.currentUser,
          _onSuccess = _this$props.onSuccess,
          replyId = _this$props.replyId,
          onInstanceReady = _this$props.onInstanceReady,
          _this$props$redirect = _this$props.redirect,
          redirect = _this$props$redirect === void 0 ? true : _this$props$redirect,
          isTopicEdit = _this$props.isTopicEdit,
          parentReplyId = _this$props.parentReplyId,
          _this$props$isControl = _this$props.isControl,
          isControl = _this$props$isControl === void 0 ? false : _this$props$isControl,
          mentionTargetReplyAuthor = _this$props.mentionTargetReplyAuthor;
      var _this$state = this.state,
          content = _this$state.content,
          attachments = _this$state.attachments;
      var avatarContent;

      if (currentUser.id) {
        if (currentUser.avatar) {
          avatarContent = (0, _preact.h)("img", {
            src: (0, _absoluteUrlRuntime.resolveUrl)(currentUser.avatar),
            alt: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
            className: "editor__avatar-img"
          });
        } else {
          avatarContent = (0, _preact.h)("div", {
            className: "default-avatar default-editor-avatar avatar-variant-".concat(currentUser.id % 10, " editor__avatar-img")
          }, (0, _userAvatar.getAvatarInitial)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.name));
        }
      } else {
        avatarContent = (0, _preact.h)("div", {
          className: "default-avatar"
        }, (0, _preact.h)(_AvatarPlaceholder.default, null));
      }

      return (0, _preact.h)("div", {
        id: "reply-editor",
        className: (0, _classnames.default)('editor', {
          'editor--open': isOpen
        })
      }, (0, _preact.h)("div", {
        className: "editor__container"
      }, isOpen ? (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref) {
        var lock = _ref.lock,
            unlock = _ref.unlock;
        return (0, _preact.h)("div", {
          className: "qa-topic-post-edit"
        }, (0, _preact.h)(_PostEditor.default, {
          type: contentType,
          data: content,
          autoFocus: true,
          disableFileAttachments: disableFileAttachments,
          topicId: parentTopicId,
          parentReplyId: parentReplyId,
          replyId: replyId,
          isControl: isControl,
          attachments: attachments,
          redirect: redirect,
          isGuest: currentUser.id === null,
          onChange: function onChange(content, attachments) {
            lock(content);

            _this2.onChange(content, attachments);
          },
          profile: isTopicEdit ? 'topicEdit' : 'reply',
          callback: mentionTargetReplyAuthor,
          onSuccess: function onSuccess(content, attachments) {
            unlock();

            if (_onSuccess) {
              _onSuccess(content, attachments);

              _this2.setState({
                content: '',
                attachments: []
              });
            } else {
              window.location.reload();
            }
          },
          onCancel: function onCancel() {
            unlock();

            if (_onCancel) {
              _onCancel();
            }
          },
          onInstanceReady: onInstanceReady,
          isTopicEdit: isTopicEdit,
          placeholder: isControl ? placeholder : 'threaded.replies.editor.placeholder'
        }));
      }) : (0, _preact.h)("button", {
        className: "editor__collapsed",
        "data-qa": "open-reply-editor",
        onClick: onFocus,
        "aria-label": "Open reply editor"
      }, (0, _preact.h)("div", {
        className: "editor__avatar"
      }, avatarContent), (0, _preact.h)("input", {
        type: "text",
        className: "editor__input",
        placeholder: placeholder,
        onFocus: currentUser.id ? onFocus : undefined,
        readOnly: true
      }))));
    }
  }]);
  return Editor;
}(_preact.Component);

exports.Editor = Editor;